module.exports = __webpack_public_path__ + "img/boat6.c382c1b6.jpg";